import React, { useEffect } from 'react';
import DesignCutting from './DesignCutting';
import { usePermissions } from '../hooks/usePermissions';

const DesignCuttingPage: React.FC = () => {
  console.log('DesignCuttingPage: Starting component render');
  const { canView, canAdd, canEdit, canDelete } = usePermissions();
  
  useEffect(() => {
    console.log('DesignCuttingPage: Component mounted');
    
    // Add a test API call to verify API connectivity
    const testApiConnection = async () => {
      try {
        console.log('DesignCuttingPage: Testing API connection...');
        const response = await fetch('/api/v1/test');
        console.log('DesignCuttingPage: API test response:', response.status);
      } catch (error) {
        console.error('DesignCuttingPage: API test failed:', error);
      }
    };
    
    testApiConnection();
    
    return () => {
      console.log('DesignCuttingPage: Component unmounted');
    };
  }, []);

  // Log permission checks for debugging
  console.log('DesignCuttingPage: Permission checks:', {
    canView: canView('design-cutting'),
    canAdd: canAdd('design-cutting'),
    canEdit: canEdit('design-cutting'),
    canDelete: canDelete('design-cutting')
  });
  
  // If the user doesn't have view permission, don't render anything
  if (!canView('design-cutting')) {
    console.log('DesignCuttingPage: User does not have view permission');
    return null;
  }
  
  console.log('DesignCuttingPage: About to render DesignCutting component');
  
  return (
    <DesignCutting
      canAdd={canAdd('design-cutting')}
      canEdit={canEdit('design-cutting')}
      canDelete={canDelete('design-cutting')}
    />
  );
};

export default DesignCuttingPage; 